document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.screen.width < 600;
    const gallerySwiper = new Swiper('.gallery-block__swiper',{
        loop: true,
        speed: 600,
        navigation: {
            nextEl: '.gallery-next',
            prevEl: '.gallery-prev'
        },
        effect: isMobile ?  undefined : 'fade',
        fadeEffect: isMobile ? undefined : { crossFade: true },
        breakpoints: {
            320: {
                spaceBetween: 20,
                slidesPerView: 1.4,
                centeredSlides: true
            },
            600:{
                slidesPerView: 1,
                centeredSlides: false
            }
        }
    });
});